import { getAvailableVideoType, getFullAccessActionName, canPlayFullOrPreview } from 'widget/ui-selectors/video-access';

import getTranslationData from './translation-data';
import getCallbackFromProps from './callback';


export default function getPlayButtonConfig(props) {
  const { channelData, videoItem, currentSiteUser } = props;

  const availableVideoType = getAvailableVideoType(channelData, videoItem, currentSiteUser);
  const fullAccessAction = getFullAccessActionName(channelData, videoItem, currentSiteUser);

  const callback = getCallbackFromProps(
    props,
    canPlayFullOrPreview(channelData, videoItem, currentSiteUser),
    fullAccessAction
  );
  const translationData = getTranslationData(availableVideoType, fullAccessAction);

  if (callback && translationData) {
    return {
      callback,
      translationData,
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/play/button-config.js